import React from 'react';
import { RefreshCcw } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';

export const PrelevementAutoOption = ({ checked, onChange, actif, carte }) => (
  actif ? (
    <p className="flex items-center gap-2 text-xs text-emerald-800 bg-emerald-50 rounded p-2" data-testid="prelevement-auto-actif">
      <RefreshCcw className="h-3.5 w-3.5" /> Prélèvement automatique actif{carte ? ` sur ${carte}` : ''} : chaque échéance est prélevée à sa date.
    </p>
  ) : (
    <label className="flex items-start gap-2 text-xs text-slate-700 cursor-pointer rounded border border-slate-200 p-2" data-testid="prelevement-auto-option">
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid="prelevement-auto-checkbox" />
      <span>J'autorise le prélèvement automatique des échéances sur la carte utilisée pour l'acompte (carte enregistrée de façon sécurisée par Stripe). En cas d'échec, une 2e tentative a lieu 3 jours plus tard, puis un lien de paiement vous est envoyé.</span>
    </label>
  )
);
